import { render, staticRenderFns } from "./Occupiers.vue?vue&type=template&id=c2def3ea&"
import script from "./Occupiers.vue?vue&type=script&lang=js&"
export * from "./Occupiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports